import React from "react";
import { Box, Paper, IconButton, Typography } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

/**
 * Purple-header collapsible panel used by the MicroSlide layout components.
 * Mirrors the look of MicroTip/CalibrationLayout.js panels.
 */
export default function CollapsiblePanel({ title, collapsed, onToggle, children }) {
    return (
        <Paper elevation={3} sx={{ display: "flex", flexDirection: "column", mt: 2 }}>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                bgcolor="#774def"
                color="#ffffff"
                px={2}
                py={1}
            >
                <Typography variant="subtitle1">{title}</Typography>
                <IconButton size="small" onClick={onToggle} sx={{ color: "white" }}>
                    {collapsed ? <ExpandMore /> : <ExpandLess />}
                </IconButton>
            </Box>
            <Box flex={1} overflow="auto" p={2} sx={{ display: collapsed ? "none" : "block" }}>
                {children}
            </Box>
        </Paper>
    );
}
